import React, { useState} from "react"
import { Wrapper, Antd, Padder, Button } from 'components'
import {SizeMe} from 'react-sizeme'
import VisibilitySensor  from 'react-visibility-sensor'

import {Layout} from "../../components"
import * as S from './styles'
import ModalPlan from './ModalPlan'
import ModalUsage from './ModalUsage'
import { isDesktop } from '../../utility'
import theme from "../../style/theme";

const Icon = Antd.Icon
const Table = Antd.Table
const usageWidth = 150



const PlanList = ({pricingPlans, currency, version, isSticky, setActivePlan}) => (
  <S.Plans version={version} isSticky={isSticky} usageWidth={usageWidth} >
  {
    pricingPlans.map((plan) => <S.Plan version={version} key={plan.title}>
      <S.PlanTitle color={plan.color}>{plan.title}</S.PlanTitle>
      <S.PlanContent>
        {plan.text && version !== "copy" && <S.PlanText>{plan.text}</S.PlanText>}
        {plan.price && !plan.priceHidden && <S.PlanPriceWrapper>
          <S.PlanPricePre>{plan.pricePre}</S.PlanPricePre>
          <S.PlanPriceCurrency>{currency}</S.PlanPriceCurrency>
          <S.PlanPrice>{plan.price}</S.PlanPrice>
          <S.PlanPricePost>{plan.pricePost}</S.PlanPricePost>
        </S.PlanPriceWrapper>}
      </S.PlanContent>
      <S.PlanFooter version={version} usageWidth={usageWidth}>
        <Button color={theme.colors.thirdary} size={version === "copy" ? "regular" : "large"} block onClick={() => setActivePlan(plan)}>{plan.ctaLabel}</Button>
        {
          version !== "copy" && plan.items.map(({description}, index) => (
            <S.Plandescription key={description} index={index}>{description}</S.Plandescription>
          ))
        }
      </S.PlanFooter>
    </S.Plan>)
  }      
</S.Plans>
)



function getTableColumns({ key, size, color, title }){


  return {
    title: () => <S.HeadCell color={color}>{title}</S.HeadCell>,
    dataIndex: key,
    key,
    width: isDesktop ? ((size.width - usageWidth) / 4) : 150,
    render: data => {
      if(!data) return null
      const isAvailable = data[0].indexOf("true") > -1 // because graphql had problems it the array cointained different primary
      return (
        <S.Cell available={isAvailable}>
        <Icon type={isAvailable ? 'check' : 'close'} />
        {data[1] && <S.Text>{data[1]}</S.Text>}
      </S.Cell>
      )}
  }
}

export default (props) => {
  const [activePlan, setActivePlan] = useState(null)
  const [isSticky, setSticky] = useState(null)
  const [modalContent, setModalContent] = useState(null)
  const { translations} = props.pageContext
  const { pricingPlans, pricingTable, currency, industries, pricingModalSummaryTable, pricingStepsLabel, primary, pricingThankyouPage, pricingFormInputs } = translations

  return(
    <Layout {...props}>
      <VisibilitySensor
        partialVisibility
        offset={{ top: 120 }}
        onChange={(e) => setSticky(!e)}
      >
        <Wrapper size="large">
          <Padder size="big">
            <PlanList setActivePlan={setActivePlan} pricingPlans={pricingPlans} currency={currency} />
          </Padder>
        </Wrapper>
      </VisibilitySensor>
      <PlanList setActivePlan={setActivePlan} pricingPlans={pricingPlans} currency={currency} version="copy" isSticky={isSticky} />
   
      <SizeMe>
      {({size}) =>  (
        <Wrapper size="large">
        <Padder size="big">
          <S.TableWrapper>
          <Table
            size="small"
            bordered
            pagination={false}
            columns={[
              {
                width: isDesktop ? usageWidth : 150,
                dataIndex: 'usage',
                key: 'usage',
                fixed: 'left',
                render: e => e && (
                  <S.Usage onClick={() => setModalContent(e)}>
                    <S.UsageText>
                        {e[0]}
                      </S.UsageText>
                      <S.IconWrapper><Icon type="info" size="small"/></S.IconWrapper>
                  </S.Usage>
                )
              },
              ...pricingPlans.map(e => getTableColumns({...e, size}))
            ]}
            dataSource={pricingTable.map((e, index) => ({...e, key: index}))}
            scroll={{ x: isDesktop ? size.innerWidth : 700 }} 
          />
          </S.TableWrapper>
          </Padder>
        </Wrapper>
        )}
    </SizeMe>
    <ModalUsage
      modalContent={modalContent}
      onCancel={() => setModalContent(null)}
    />
    <ModalPlan
      activePlan={activePlan}
      onCancel={() => setActivePlan(null)}
      industries={industries}
      pricingModalSummaryTable={pricingModalSummaryTable}
      currency={currency}
      pricingStepsLabel={pricingStepsLabel}
      primary={primary}
      pricingThankyouPage={pricingThankyouPage}
      pricingFormInputs={pricingFormInputs}
    />
  </Layout>
  )
}
 


